var Model = require("../../../types/Model.js");

module.exports = new Model({
	name: "deviceIHO2",
	listeners: listeners,
	triggers: triggers,
	init: init,
	uninit: uninit,

	handleProgressUpdated: handleProgressUpdated,
	handleBatteryReading: handleBatteryReading,
	handleFinishReading: handleFinishReading,
	disconnect: disconnect,
	clean: clean
});

var MAX_PROGRESS = 5;

function init() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];
}

function uninit() {
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;

	this._progress = 0;

	this._batteryReadings = [];
	this._readings = [];
}

function triggers(){
	return {
		"info": info,
		"ready": ready,
		"clean": clean,
		"disconnect": disconnect,
		"failed": failed
	};
}

function listeners(){
	return {
		"bluetooth:event": handleEvent,
		"bluetooth:written": handleWritten
	};
}

function info(){
	var trigger = "deviceoxygen:trigger:begin";
	var message = "myhealthdevice.ihspo2prepmessage";

	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.prepare_blood_oxygen_reading",
		items: {
			prepare: {
				message: message,
				type: "confirmcancel",
				trigger: trigger,
				cancelTrigger: "myhealthdevice:trigger:clean"
			}
		}
	});

	this.emit("usermetrics:trigger:track", "open read from device modal for blood oxygen", {
		"device type": "IHO2",
	});
}

function ready(data){
	this._deviceMac = data.mac;
	this._isListening = true;

	this.emit("bluetooth:trigger:read", {
		service: "DEVICE_BATTERY_SERVICE",
		characteristic: "DEVICE_BATTERY_CHARACTERISTIC",
		device: this._deviceMac
	});
}

function handleEvent(event){
	var isListening = this._isListening;
	var readings = this._readings;

	var char = event.characteristic;
	if(!isListening) return;

	var data = event.data;

	this._isRead = true;
	if(char === "IHO2_SPOT_CHECK"){
		this._readings = readings.concat(data);
		this._hasReadings = true;
		this._progress = MAX_PROGRESS;
		this.handleFinishReading();
	} else if (char === "IHO2_REAL_TIME_CHECK") {
		this._readings = readings.concat(data);
		if(this._progress === MAX_PROGRESS)
			this.handleFinishReading();
	} else if(char === "DEVICE_BATTERY_CHARACTERISTIC"){
		this._batteryReadings = [].concat(data);
		this.handleBatteryReading();
	}
	this.handleProgressUpdated();
}

function handleProgressUpdated(){
	var progress = this._progress;

	if(progress < MAX_PROGRESS)
		progress++;

	this.emit("feedbackmodal:trigger:update", {
		reading: {
			type: "progress",
			message: "myhealthdevice.reading",
			progress: progress / MAX_PROGRESS,
			cancelTrigger: "myhealthdevice:trigger:clean"
		}
	});

	this._progress = progress;
}

function handleFinishReading(){
	var readings = this._readings;
	var isRead = this._isRead;
	if(!isRead) return;

	var reading = formatReading(readings);
	if(!reading) return;

	this.dispatch("done", reading);
	this.disconnect();
}

function disconnect(){
	var isListening = this._isListening;

	if(isListening){
		this._isListening = false;
		this.emit("bluetooth:trigger:listen:stop", {
			service: "IHO2_SERVICE",
			characteristic: "IHO2_SPOT_CHECK",
			device: this._deviceMac
		});

		this.emit("bluetooth:trigger:listen:stop", {
			service: "IHO2_SERVICE",
			characteristic: "IHO2_REAL_TIME_CHECK",
			device: this._deviceMac
		});
	}
}

function failed(){
	this.emit("feedbackmodal:trigger:show", {
		title: "myhealthdevice.failedtitle",
		items: {
			continue: {
				message: "myhealthdevice.failed",
				type: "confirmcancel",
				trigger: "myhealthdevice:trigger:begin",
				cancelTrigger: "myhealthdevice:trigger:clean",
			}
		}
	});
}

function clean(){
	this._isListening = false;
	this._isRead = false;
	this._deviceMac = null;
	this._progress = 0;

	this._readings = [];
	this._batteryReadings = [];
}

function formatReading(readings){
	var pulseRate = Math.floor((readings.reduce(function (ongoing, next) {
		return ongoing + next[3];
	}, 0)) / readings.length);
	var oxygenSaturation = Math.floor((readings.reduce(function (ongoing, next) {
		return ongoing + next[1];
	}, 0)) / readings.length);

	if (oxygenSaturation > 100 || pulseRate === 255) return false;
	else return {
		pulserate: pulseRate,
		oxygensaturation: oxygenSaturation
	};
}

function handleWritten(){
	var isListening = this._isListening;

	if(!isListening) return;

	this.handleProgressUpdated();

	this.emit("bluetooth:trigger:listen", {
		service: "IHO2_SERVICE",
		characteristic: "IHO2_SPOT_CHECK",
		device: this._deviceMac
	});

	this.emit("bluetooth:trigger:listen", {
		service: "IHO2_SERVICE",
		characteristic: "IHO2_REAL_TIME_CHECK",
		device: this._deviceMac
	});
}

function handleBatteryReading(){
	var readings = this._batteryReadings;
	var reading = formatBatteryReading(readings);
	this.dispatch("battery", reading);

	this.emit("bluetooth:trigger:write", {
		service: "GATT_CURRENT_TIME_SERVICE",
		characteristic: "GATT_CURRENT_TIME_CHARACTERISTIC",
		device: this._deviceMac,
		value: getCurrentTimeValue()
	});

}

function formatBatteryReading(readings){
	var latestReading = readings[readings.length - 1];
	return latestReading[0];
}

// https://stackoverflow.com/questions/53094442/react-native-bluetooth-app-current-time-service
function getCurrentTimeValue(){
	// Order:
	// Year_LSO (byte), Year_MSO (byte),  Month (byte), DayOfMonth (byte), Hours (byte), Minutes (byte), Seconds (byte), DayOfWeek (byte), Fractions (byte), AdjReason (byte)

	const fullDateTime = new Date();
	const year = fullDateTime.getFullYear();
	const month = fullDateTime.getMonth() + 1;
	const dayOfMonth = fullDateTime.getDate();
	const hours = fullDateTime.getHours();
	const minutes = fullDateTime.getMinutes();
	const seconds = fullDateTime.getSeconds();
	let dayOfWeek = fullDateTime.getDay();
	if (dayOfWeek === 0) {
		dayOfWeek = 7;
	}
	const fraction1000 = fullDateTime.getMilliseconds();
	const adjustFractionDenom = 256 / 1000;
	const fraction256 = Math.round(fraction1000 * adjustFractionDenom);

	const yearHex = padHex(year.toString(16), 4);
	const yearHexMSO = parseInt(yearHex.substr(0, 2), 16);
	const yearHexLSO = parseInt(yearHex.substr(2, 2), 16);
	const monthHex = parseInt(padHex(month.toString(16), 2), 16);
	const dayOfMonthHex = parseInt(padHex(dayOfMonth.toString(16), 2), 16);
	const hoursHex = parseInt(padHex(hours.toString(16), 2), 16);
	const minutesHex = parseInt(padHex(minutes.toString(16), 2), 16);
	const secondsHex = parseInt(padHex(seconds.toString(16), 2), 16);
	const dayOfWeekHex = parseInt(padHex(dayOfWeek.toString(16), 2), 16);
	const fractionHex = parseInt(padHex(fraction256.toString(16), 2), 16);

	const currentTime = [yearHexLSO, yearHexMSO, monthHex, dayOfMonthHex, hoursHex, minutesHex, secondsHex, dayOfWeekHex, fractionHex, 0x02];
	return currentTime;
}

function padHex(str, dig){
	while (str.length !== dig) str = `0${str}`;
	return str;
}
